module.exports = __webpack_public_path__ + "img/6.d07c015a.png";